(() => {
  const constant = window.hanlin.constant
  const adIndexStyle = `<style>


  ul.slides-point {
    position: absolute;
    z-index: 99;
    left: 0;
    right: 0;
    top: 88%;
    margin: auto;
  }
  a img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: auto;
    transform: translate(-50%, -50%);
  }

  @media screen and (max-width:1024px) {
    a img  {
      position: sticky;
      left: 0;
      top: 0;
      transform: none;
      bottom: 0;
    }

    ul li a img  {
      position: sticky;
      left: 0;
      top: 0;
      transform: none;
      bottom: 0;
    }
  }


  @media screen and (min-width:768px) and (max-width:820px) {
    a img  {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: auto;
      transform: translate(-50%, -50%);
    }

    ul li a img  {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: auto;
      transform: translate(-50%, -50%);
    }
  }

  @media screen and (min-width:360px) and (max-width:759px) {
    a img {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: auto;
      transform: translate(-50%, -50%);
    }

    ul li a img {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: auto;
      transform: translate(-50%, -50%);
    }
  }

  </style>`
  const createSubjectTemplate = () => {
    return `
      <link rel="stylesheet" href="../../css/reset.css">
      <link rel="stylesheet" href="../../css/header.css">
      <link rel="stylesheet" href="../../css/all.css">
      <link rel="stylesheet" href="../../css/flexslider.css">
      <script src="../../js/jquery.flexslider-min.js"></script>
      <source class="ad">
          <a class="imgAdHref" target="_blank">
            <picture>
              <source class="imgAdSource" media="(max-width: 768px)" >
              <img class="imgAdImg" alt="" width="100%">
            </picture>
          </a>

          <!-- 切換point -->
          <ul class="slides-point"></ul>
      </source>
    `
  }

  const createIndexAdTemplate = () => {
    return `
      <link rel="stylesheet" href="../../css/index.css">
      <link rel="stylesheet" href="../../css/flexslider.css">
      <script src="../../js/jquery.flexslider-min.js"></script>
      ${adIndexStyle}
      <source class="ad">
        <a class="imgAdHref" target="_blank">
          <picture>
            <source class="imgAdSource" media="(max-width: 768px)" >
            <img class="imgAdImg" alt="" width="100%">
          </picture>
        </a>

        <!-- 切換point -->
        <ul class="slides-point"></ul>
      </source>
    `
  }

  customElements.define('ad-slides', class extends HTMLElement {
    constructor() {
      super()
      const url = new URL(window.location.href)
      this.edu = url.searchParams.get("edu") ? url.searchParams.get("edu") : this.getEudFromUrl()
      this.subject = url.searchParams.get("subject") ? url.searchParams.get("subject") : "首頁"
      this.type = null
      this.saleInfo = null
      this.clickLock = false
      this.attachShadow({ mode: 'open' })


    }

    async connectedCallback(){
      this.type = this.getAttribute("type")
      if (this.type === constant.AD_DISPLAY_TYPE.INDEX) {
        this.shadowRoot.innerHTML = createIndexAdTemplate()
      } else if (this.type === constant.AD_DISPLAY_TYPE.SUBJECT) {
        this.shadowRoot.innerHTML = createSubjectTemplate()
      }

      await this.updateSaleUI()
      this.handleUpdateSubjectEvent()
    }


    slidePointAutoClick(){
      const firstSlidePoint = this.shadowRoot.querySelector(".slides-point li[data-index='0']")
      firstSlidePoint.click()

      clearInterval(sessionStorage.getItem("intervalId"));
      if (this.saleInfo && this.saleInfo.length > 1){
        let intervalId = {};
        intervalId[0] = setInterval(() => this.clickNextSlidePoint(), 5000);
        sessionStorage.setItem("intervalId", intervalId[0])
      }
    }
    clickNextSlidePoint(){
      const currentLi = this.shadowRoot.querySelector("ul.slides-point li.current")
      const firstLi = this.shadowRoot.querySelector("ul.slides-point li[data-index='0']")
      let nextLi = null
      if (currentLi) {
        nextLi = currentLi.nextElementSibling
      }

      if (nextLi){
        nextLi.click()
      } else {
        if (firstLi) firstLi.click()

      }
    }

    async updateSaleUI(){
      const resp = await saleSvc.retrieveDisplaySales(this.edu, this.subject)
      this.saleInfo = resp.data
      const content = this.shadowRoot.querySelector(".slides-point")
      this.clearAd()

      this.saleInfo.forEach((sale, index) => {
        const li = document.createElement("li")
        li.setAttribute("data-link", sale.hyperLink)
        li.setAttribute("data-edu", sale.displayEdu)
        li.setAttribute("data-subject", sale.displaySubject)
        li.setAttribute("data-name", sale.name)
        li.setAttribute("data-urlhor", sale.imgUrlHorizon)
        li.setAttribute("data-urlvert", sale.imgUrlVertical)
        li.setAttribute("data-index", index)
        const a = document.createElement("a")
        li.appendChild(a)
        content.appendChild(li)
      })

      // add events
      if (this.saleInfo && this.saleInfo.length > 0) {
        this.slidePointClickEvent()
        this.slidePointAutoClick()
      }

    }

    clearAd(){
      const content = this.shadowRoot.querySelector(".slides-point")
      if (content) content.innerHTML = ``

      const imgAdHref = this.shadowRoot.querySelector(".imgAdHref")
      const imgAdImg = this.shadowRoot.querySelector(".imgAdImg")
      const imgAdSource = this.shadowRoot.querySelector(".imgAdSource")
      if (imgAdHref) imgAdHref.setAttribute("href", "#")
      if (imgAdImg) imgAdImg.setAttribute("src", "")
      if (imgAdSource) imgAdSource.setAttribute("srcset", "")
    }

    slidePointClickEvent(){
      const lis = this.shadowRoot.querySelectorAll(".slides-point li")
      const imgAd = this.shadowRoot.querySelector(".imgAdImg")
      const imgAdHref = this.shadowRoot.querySelector(".imgAdHref")
      const imgAdSource = this.shadowRoot.querySelector(".imgAdSource")
      lis.forEach((li) => {
        li.addEventListener("click", () => {
          if (this.clickLock) return
          this.clickLock = true
          const urlHorizon = li.getAttribute("data-urlhor")
          const urlVertical = li.getAttribute("data-urlvert")
          const link = li.getAttribute("data-link")
          const edu = li.getAttribute("data-edu")
          const subject = li.getAttribute("data-subject")
          const name = li.getAttribute("data-name")

          // remove other current
          lis.forEach((l) => l.classList.remove("current"))


          // -- imgAd horizon
          // fadeout the before image
          $(imgAd).fadeOut(300, () => {
            imgAd.setAttribute("src", urlHorizon)
            imgAdHref.setAttribute("data-ga4-value", `${edu}_${subject}_${name}`)
            imgAdHref.setAttribute("data-ga4-event", `${edu}_${subject}_${name}`)
            if (link !== ""){
              imgAdHref.setAttribute("href", link)
            } else {
              imgAdHref.removeAttribute("href")
            }
          })

          // fadein
          $(imgAd).fadeIn(500, () => {
            this.clickLock = false
          })

          // -- imgAdSource verticle
          // fade out
          $(imgAdSource).fadeOut(300, () => {
            imgAdSource.setAttribute("srcset", urlVertical)
            imgAdHref.setAttribute("data-ga4-value", `${edu}_${subject}_${name}`)
            imgAdHref.setAttribute("data-ga4-event", `${edu}_${subject}_${name}`)
            if (link !== ""){
              imgAdHref.setAttribute("href", link)
            } else {
              imgAdHref.removeAttribute("href")
            }
          })

          // fadein
          $(imgAdSource).fadeIn(500, () => {
            this.clickLock = false
          })

          li.classList.add("current")
        })
      })

    }


    handleUpdateSubjectEvent(){
       window.addEventListener("updateSubjectEvent", async (e) => {
         this.subject = e.detail.subject
         await this.updateSaleUI()
       })
    }

    getEudFromUrl = () => {
      // 檢查
      const url = window.location.href;
      if (url.includes('/el/')) {
        return  "國小";
      } else if (url.includes('/jr/')) {
        return "國中";
      }else if (url.includes('/sh/')) {
        return "高中";
      }
    }



  })
})(window)
